
import { ProjectHeader } from "@/components/projects/ProjectHeader";

export default function Help() {
  return (
    <div className="min-h-screen w-full site-gradient">
      <div className="container mx-auto py-8 px-4">
        <div className="max-w-4xl mx-auto space-y-8">
          <ProjectHeader />
          
          <div className="glass-card p-8 rounded-xl space-y-8">
            <h1 className="text-4xl font-bold">Help Center</h1>
            
            <section className="space-y-6">
              <h2 className="text-2xl font-semibold">Getting Started</h2>
              <div className="space-y-4">
                <div className="space-y-2">
                  <h3 className="text-xl font-medium">Creating Your First Project</h3>
                  <p className="text-muted-foreground">
                    To create a new project, click the "New Project" button on your dashboard. 
                    Fill in the project details including name, description, and budget information if applicable.
                  </p>
                </div>
                
                <div className="space-y-2">
                  <h3 className="text-xl font-medium">Managing Gear Lists</h3>
                  <p className="text-muted-foreground">
                    Add gear items to your project by navigating to the gear section and clicking "Add Item". 
                    You can specify quantities, costs, and assign items to different categories.
                  </p>
                </div>
              </div>
            </section>

            <section className="space-y-6">
              <h2 className="text-2xl font-semibold">Crew Management</h2>
              <div className="space-y-4">
                <div className="space-y-2">
                  <h3 className="text-xl font-medium">Crew Contacts</h3>
                  <p className="text-muted-foreground">
                    Maintain a personal directory of crew contacts that you frequently work with. Access your contacts
                    from the Contacts page in the navigation menu. Add essential information like roles, contact details,
                    and notes for each crew member.
                  </p>
                </div>

                <div className="space-y-2">
                  <h3 className="text-xl font-medium">Adding Crew to Projects</h3>
                  <p className="text-muted-foreground">
                    When creating crew lists for your projects, you can quickly add members from your contacts.
                    Navigate to the Crew tab in your project and click "Add from Contacts" to select crew members
                    from your contact list. All their information will be automatically populated.
                  </p>
                </div>

                <div className="space-y-2">
                  <h3 className="text-xl font-medium">Project Collaboration</h3>
                  <p className="text-muted-foreground">
                    Share your projects with crew members to enable collaboration. From the Share tab in your project:
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-muted-foreground pl-4">
                    <li>Click "Share with User" to invite crew members</li>
                    <li>Choose between "View only" or "Can edit" permissions</li>
                    <li>Crew members will receive access to the project once they accept the invitation</li>
                    <li>Track who has access to your project and manage their permissions at any time</li>
                  </ul>
                </div>
              </div>
            </section>

            <section className="space-y-6">
              <h2 className="text-2xl font-semibold">Features</h2>
              <div className="space-y-4">
                <div className="space-y-2">
                  <h3 className="text-xl font-medium">Budget Tracking</h3>
                  <p className="text-muted-foreground">
                    Enable budget tracking to monitor your project expenses. Set budgets for camera and G&E departments,
                    and track spending in real-time.
                  </p>
                </div>
                
                <div className="space-y-2">
                  <h3 className="text-xl font-medium">Sharing Projects</h3>
                  <p className="text-muted-foreground">
                    Share your projects with team members by generating a share link or inviting them directly.
                    Control access levels and manage permissions for each collaborator.
                  </p>
                </div>

                <div className="space-y-2">
                  <h3 className="text-xl font-medium">Inventory Management</h3>
                  <p className="text-muted-foreground">
                    Keep track of your personal inventory separate from project gear lists.
                    Easily add items from your inventory to project gear lists.
                  </p>
                </div>
              </div>
            </section>

            <section className="space-y-6">
              <h2 className="text-2xl font-semibold">Need More Help?</h2>
              <p className="text-muted-foreground">
                If you need additional assistance, please contact our support team at{" "}
                <a 
                  href="mailto:info@preptcine.com" 
                  className="text-primary hover:text-primary/80 transition-colors"
                >
                  info@preptcine.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
